import React from "react";
// import ReactDOM from 'react-dom';
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import axios from "axios";
import { store, persistor } from "./store";
import AppLoader from "./_common/components/elements/full-page-loader/appLoader";
import { ACTIONS, API_URL, APP_STAGE, SAGA_ACTIONS, SELECTED_EVENT_STORAGE, STORAGE } from "./_config";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-datepicker/dist/react-datepicker.css";
// import { SocketProvider } from "./_common/hooks/custom/SocketContext";

// Create root once and reuse it
const container = document.getElementById("root");
const root = createRoot(container!);

function render() {
  root.render(
    <React.Fragment>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          {/* <SocketProvider> */}
          <React.Fragment>
            <AppLoader />
            <App />
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={true}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              style={{ zIndex: 99999 }}
            />
          </React.Fragment>
          {/* </SocketProvider> */}
        </PersistGate>
      </Provider>
    </React.Fragment>
  );
}

// Function to validate token and fetch user details
const validateAndInitialize = (authToken: string) => {
  axios({
    method: "GET",
    url: API_URL.USER.DETAILS,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  })
    .then((success) => {
      const userData = success.data.data;
      store.dispatch({
        type: ACTIONS.USER.ME,
        payload: userData,
      });

      // Fetch permissions for member users on app initialization
      if (userData && userData.user_type === "member" && userData.id) {
        // Use saga to fetch permissions instead of direct axios call
        store.dispatch({
          type: SAGA_ACTIONS.USER.GET_PERMISSIONS,
          payload: { userId: userData.id },
          callbackSuccess: (response: any) => {
            console.log("User permissions loaded successfully on app initialization");
          },
          callbackError: (error: any) => {
            console.warn("Failed to load user permissions on app initialization:", error);
          },
        });
      }

      render();
    })
    .catch((error) => {
      //console.log("Error src/index.tsx file : ", error);
      localStorage.removeItem(STORAGE);
      localStorage.removeItem(SELECTED_EVENT_STORAGE);
      localStorage.removeItem("DR-JOBS-REMEMBER-EMAIL");
      localStorage.removeItem("DR-JOBS-REMEMBER-ME");
      store.dispatch({
        type: ACTIONS.USER.LOGOUT,
      });
      render();
    });
};

// Check for token in localStorage (we always store tokens there now for multi-tab support)
let token = localStorage.getItem(STORAGE);

// If no token found in storage, check persisted Redux state (happens when opening new tabs)
if (!token) {
  // Subscribe to store to wait for rehydration
  const unsubscribe = store.subscribe(() => {
    const state = store.getState();
    // Check if state has been rehydrated and has a token
    if (state._persist && state._persist.rehydrated) {
      unsubscribe(); // Stop listening

      if (state.user && state.user.token && typeof state.user.token === "string") {
        const persistedToken = state.user.token;
        token = persistedToken;
        // Restore token to localStorage for subsequent API requests
        localStorage.setItem(STORAGE, persistedToken);

        // Validate the persisted token
        try {
          validateAndInitialize(persistedToken);
        } catch (e) {
          localStorage.removeItem(STORAGE);
          render();
        }
      } else {
        // No token in persisted state either, just render
        render();
      }
    }
  });

  // Fallback: render after 500ms if rehydration doesn't complete
  setTimeout(() => {
    unsubscribe();
    if (!token) {
      render();
    }
  }, 500);
} else {
  // Token exists in storage, validate it
  try {
    validateAndInitialize(token);
  } catch (e) {
    localStorage.removeItem(STORAGE);
    render();
  }
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
if (APP_STAGE === "prod") {
  serviceWorker.register();
} else {
  serviceWorker.unregister();
}
